import {UFATLogoIcon} from './UFATLogoIcon';

export const FooterBrand = () => (
  <span className="inline-flex items-center gap-2 font-extrabold text-white">
    <span className="inline-flex h-[30px] w-6 items-center justify-center text-white" aria-hidden="true">
      <UFATLogoIcon />
    </span>
    <span>United Foundation for Arts & Technology</span>
  </span>
);
